import { render, staticRenderFns } from "./IconOpenMouthFace.vue?vue&type=template&id=7119e7ec&"
import script from "./IconOpenMouthFace.vue?vue&type=script&lang=js&"
export * from "./IconOpenMouthFace.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports